module.exports = __webpack_public_path__ + "media/images/flags/tw-54d619ea3985fafba58febe972ac2ada.svg";